<template>
  <view>
    <cube-button bindtap="showActionSheet">action-sheet</cube-button>
    <cube-action-sheet
      wx:ref="actionSheet"
      title="我是标题~~~"
      inputData="{{inputData}}"
      bindselect="onSelect"
    />
    <cube-toast
      txt="{{ selectContent }}"
      wx:ref="selectToast">
    </cube-toast>
  </view>
</template>

<script>
import { createComponent } from '@mpxjs/core'

createComponent({
  data: {
    inputData: [
      {
        content: 'align-center',
        class: 'cube-foo'
      },
      {
        content: 'align-left',
        align: 'left'
      },
      {
        content: 'align-right',
        align: 'right'
      }
    ],
    isVisible: false,
    selectContent: ''
  },
  methods: {
    onSelect(selectData) {
      const { item } = selectData.detail
      this.selectContent = `Clicked: ${item.content}`
      this.$refs.selectToast.show()
    },
    showActionSheet() {
      this.$refs.actionSheet.show()
    }
  }
})
</script>

<style lang="stylus">

</style>

<script type="application/json">
  {
    "usingComponents": {
      "cube-button": "@mpxjs/mpx-cube-ui/src/components/button/index",
      "cube-action-sheet": "@mpxjs/mpx-cube-ui/src/components/action-sheet/index",
      "cube-toast": "@mpxjs/mpx-cube-ui/src/components/toast/index"
    }
  }
</script>
